import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ranged-integer',
  templateUrl: './ranged-integer.component.html',
  styleUrls: ['./ranged-integer.component.scss']
})
export class RangedIntegerComponent implements OnInit,OnChanges {
  @Input() value:number;
  @Input() min:number;
  @Input() max:number;
  @Input() step = 1;
  @Input() debounceChange = 500;
  @Input() disabled = false;
  @Output() valueChanged = new EventEmitter<number>();
  atMin:boolean;
  atMax:boolean;
  valueChangeTimeout = -1;
  numbers: number[] = [];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.evaluateLimits();
  }

  ngOnInit(): void {
    this.evaluateLimits();
  }

  evaluateLimits() {
    this.atMin = this.value <= this.min;
    this.atMax = this.value >= this.max;
    this.numbers = Array(this.max-this.min+1).fill(0).map((x,i)=>i+this.min);
  }

  move(amt:number):void{
    this.value += amt;
    this.evaluateLimits();

    this.fireChange();
  }

  fireChange() {
    if(this.valueChangeTimeout>=0){
      clearTimeout(this.valueChangeTimeout);
    }
    this.valueChangeTimeout = window.setTimeout(() => {
      this.valueChanged.emit(this.value);
      this.valueChangeTimeout = -1;
    }, this.debounceChange);
  }
}
